angular.module('omfm').directive('wkFiltersGroup', WkFiltersGroupDirective);

WkFiltersGroupDirective.$inject = [];

function WkFiltersGroupDirective() {
	return {
		restrict:    "EA",
		replace:     true,
		scope: {

		},
		templateUrl: "/app/omfm/templates/wmFiltersGroup.html",
		link:        function ($scope) {

		}
	}
}